module.exports = __webpack_public_path__ + "img/Marca2.c9c07dd9.jpg";